import React, { FC } from 'react';
import { AddEntityWatcherButton } from '../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import styles from './law_firm_follow.module.scss';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';

const source = 'law_firm_page';

type Props = {
  lawOfficeIdGroup: string;
  firmName: string;
};

export const LawFirmFollow: FC<Props> = ({ firmName, lawOfficeIdGroup }) => {
  const { openRestrictedModal } = useRestrictedModal();
  return (
    <div className={styles.container} id="add-watcher-law-firm">
      <AddEntityWatcherButton
        queryParams={{ oid: lawOfficeIdGroup, q: firmName }}
        uniqueId={lawOfficeIdGroup}
        restrict={() =>
          openRestrictedModal({ source: 'want_to_follow_law_firm' })
        }
        source={source}
      />
    </div>
  );
};
